module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm",
    attrs: {
      "id": "int"
    }
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/toc#int1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "int"
  }, [_vm._v("A casserole is something to be shared—something warm, rich, usually ooey-gooey, and worthy of a gathering on its own. I imagine something cheesy, like "), _c('span', {
    attrs: {
      "href": "#/OEBPS/s017#page39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Smoked Gouda Mac and Cheese")]), _vm._v(", at the center of a table, bright-patterned linens, flowers, maybe bread crumbs or a fading stain from spilled wine. I picture laughing parents talking about their day, a sticky little hand reaching in for dessert, and full plates leaving saucy stains behind.")]), _vm._v(" "), _c('p', {
    staticClass: "int1"
  }, [_vm._v("I was born and raised not far from my grandparents’ farm in Minnesota. I spent most of my childhood there, and after growing up on cheesy corn-filled home-style meals, I flew far overseas to be classically trained in French cuisine. I went from mashing potatoes in a country kitchen to precisely dicing them in a three-Michelin-starred restaurant in Avignon, France, and it is safe to say that my days of making casseroles came to a screeching halt. I spent the next several years in fine dining entertaining and innovation, only to end up right back in the Midwest, making casseroles in my home kitchen. The reason is simple—I realized that I was passionate about combining ease with elegance. A dish doesn’t have to be complicated to be creative. You don’t need multiple pots and pans to find flavor. And with the proper tools, tips, and techniques, anyone can cook memorable meals. The beauty behind these dishes is their simplicity, but each is packed with flavor and worthy of a photo, characteristics that give you reason to whip up these family favorites any day of the week.")]), _vm._v(" "), _c('p', {
    staticClass: "int1"
  }, [_vm._v("One of my favorites is the "), _c('span', {
    attrs: {
      "href": "#/OEBPS/s030#page67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Country Chicken and Spinach Casserole")]), _vm._v(". The "), _c('span', {
    attrs: {
      "href": "#/OEBPS/s016#page36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Party Popper Potato Puff Casserole")]), _vm._v(" is the perfect thing to bring to a soccer game or a tailgate, and will be welcomed with open arms on a cold autumn day. The "), _c('a', {
    attrs: {
      "href": "#/OEBPS/s001#page4"
    }
  }, [_vm._v("Layered Ham and Cheese Croissant Casserole")]), _vm._v(" is my go-to brunch recipe, and the "), _c('span', {
    attrs: {
      "href": "#/OEBPS/s098#page212",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20-Minute Chocolate Candy Cookie Casserole")]), _vm._v(" is a quick and easy crowd-pleasing dessert! You’ll find my recipe for "), _c('span', {
    attrs: {
      "href": "#/OEBPS/s091#page197",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Easy Baked Goulash")]), _vm._v(", a beef casserole that I made while filming on the Food Network; and "), _c('span', {
    attrs: {
      "href": "#/OEBPS/s036#page79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One-Pot Chicken Cordon Bleu Casserole")]), _vm._v(", a dish that reminds me of when my husband and I first started dating.")]), _vm._v(" "), _c('p', {
    staticClass: "int1"
  }, [_vm._v("I’ve used my experience and excitement for food and entertaining to create each one of these 103 casseroles in a unique way. Why 103? When you come to my house for dinner, I want you to know you can always bring a friend, or two, or three … and for those who have been to my home, you know firsthand that guests tend to multiply as the food continues to come out of the oven and cocktails are poured. One hundred recipes felt too rigid, too finite. By adding the extra three it became more welcoming, a reminder that there is always more room at the table, especially when a casserole sits in the center of it.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2225420e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/int.vue
// module id = 78
// module chunks = 0